"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.matchTranslationKeyOrFallback = exports.matchLanguageOrFallback = void 0;
var translations_1 = require("../i18n/translations");
var typeUtils_1 = require("../typeUtils");
function matchLanguageOrFallback(items, targetLanguage, selectedVariation) {
    var validEntries = items.filter(function (v) { return v.variations && v.variations[0] === selectedVariation; });
    return (0, typeUtils_1.getTranslationFromArray)(validEntries, targetLanguage);
}
exports.matchLanguageOrFallback = matchLanguageOrFallback;
function matchTranslationKeyOrFallback(translationKey, languageCode) {
    if (!translations_1.translations[translationKey]) {
        return { language: languageCode, text: translationKey };
    }
    var translationsArray = Object.keys(translations_1.translations[translationKey]).map(function (langStr) {
        var language = langStr;
        var translatedEntry = translations_1.translations[translationKey];
        if (!translatedEntry || !Object.keys(translatedEntry).includes(language)) {
            return { language: language, text: translationKey };
        }
        var text = translatedEntry[language] || translationKey;
        return { language: language, text: text };
    }).filter(function (translation) { return !!translation.text; });
    return (0, typeUtils_1.getTranslationFromArray)(translationsArray, languageCode) || { language: languageCode, text: translationKey };
}
exports.matchTranslationKeyOrFallback = matchTranslationKeyOrFallback;
//# sourceMappingURL=language-fallback.js.map